import type { FC } from "react";

import { requestFeature } from "pro-features/components/Modals/src/HookModal/services/requestFeature";

import FeatureUpgradeBanner from "../components/FeatureUpgradeBanner/FeatureUpgradeBanner";
import trackingService from "../services/tracking/trackingService";

interface ISdkFeatureUpgradeBannerProps {
    hasHeader?: boolean;
    isSubmitted: boolean;
    onSubmit: () => void;
}

const SdkFeatureUpgradeBanner: FC<ISdkFeatureUpgradeBannerProps> = ({ hasHeader = false, isSubmitted, onSubmit }) => {
    const TRIAL_BANNER_TEXT_KEYS = {
        contentHook: "si.find_apps.filters.sdk.hook.content",
        headerHook: "si.find_apps.filters.sdk.hook.header",
        buttonHook: "si.find_apps.filters.sdk.hook.button",
        headerKey: "si.find_apps.filters.sdks.modal.title",
    };

    return (
        <FeatureUpgradeBanner
            titleKey={TRIAL_BANNER_TEXT_KEYS.headerHook}
            subtitleKey={TRIAL_BANNER_TEXT_KEYS.contentHook}
            buttonTextKey={TRIAL_BANNER_TEXT_KEYS.buttonHook}
            headerKey={hasHeader ? "si.find_apps.filters.sdks.modal.title" : undefined}
            onSubmit={() => {
                onSubmit();
                trackingService.trackFeatureAccessRequested("Apps SDKs");
                void requestFeature("Apps SDKs");
            }}
            isSubmitted={isSubmitted}
        />
    );
};

export default SdkFeatureUpgradeBanner;
